const figure = "_uxsf1ftcit3";
const imageWrapper = "_uxsi1jmd99e";
const contextMenu = "_uxscgx9ncy";
const latexFormula = "_uxsl1erwwpe";

export { contextMenu, figure, imageWrapper, latexFormula };
import "./spec.image.comp.style.linaria.module.css";
//# sourceMappingURL=spec.image.comp.style.js.map
